export const iconFontAwesomeHumanitarianTrashCan = (
	<i className="fa-solid fa-trash-can"></i>
);
